module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsYearly@2x.5128ed1.webp";